

<template>
  <div class="select-row-table">
    <el-popover
      placement="bottom-start"
      width="200"
      trigger="click"
      >
      <div class="wrap">
        <div v-for="(item, index) in curSelectOptions" :key="index">
          <el-checkbox v-model="item.checked" :disabled="item.disabled" @change="change">{{item.name}}</el-checkbox>
        </div>
      </div>
      <el-button slot="reference" style="font-weight: bold;">
        <i class="iconfont icon-img_caid"></i>&nbsp;<i class="iconfont icon-icon_back"></i>
      </el-button>
    </el-popover>
  </div>
</template>

<script>
import Store from '@/utils/localStore/index'
export default {
  name: 'selectRowTable',
  data() {
    return {
      localName: 'tableColName--' + this.$route.name,
      curSelectOptions: [],
    }
  },
  methods: {
    change(e) {
      Store.set(this.localName, this.curSelectOptions);
      this.changeEmit();
    },
    changeEmit() {
      this.$emit('change', this.curSelectOptions);
    }
  },
  props: {
    selectOptions: {
      type: Array,
      default: [],
    },
  },
  mounted() {
    if(!Store.get(this.localName)) {
      Store.set(this.localName, this.selectOptions);
      this.curSelectOptions = this.selectOptions;
      this.changeEmit();
    } else {
      this.curSelectOptions =  Store.get(this.localName, this.selectOptions);
      this.changeEmit();
    }
  }
};
</script>

<style scoped lang="scss">
  .select-row-table {
    display: inline-block;
    margin-left: 10px;
  }
  .wrap {
    min-width: 100px;
    padding: 20px 10px;
    box-sizing: border-box;
    &>div {
      margin-bottom: 10px;
    }
  }
  .iconfont {
    font-size: 14px;
  }
</style>
